export const BOARD_TYPES = Object.freeze({
  GROUP: 1,
  SIGNUP: 2,
  REPORT: 3,
});

export const NAME_ACCESSOR = "name";

// TODO manually keep this up to date
// enum BoardColumnType: int
// {
//     case Boolean = 1;
//     case Text = 2;
//     case Number = 3;
//     case ExtendedField_Text = 4;
//     case ExtendedField_Date = 5;
//     case ExtendedField_Number = 6;
//     case ExtendedField_Address = 7;
//     case ExtendedField_Picker = 8;
//     case ExtendedField_MembershipStatus = 9;
//     case Signups_ConfirmationNumber = 10;
//     case Signups_ItemsSignedUpFor = 11;
//     case Signups_SignedUpDate = 12;
//     case Signups_NumberOfItems = 13;
//     case Signups_HasBeenPaidFor = 14;
// }
export const COLUMN_TYPES = Object.freeze({
  BOOL: 1,
  TEXT: 2,
  NUMBER: 3,

  EXTENDED_FIELDS_TEXT: 4,
  EXTENDED_FIELDS_DATE: 5,
  EXTENDED_FIELDS_NUMBER: 6,
  EXTENDED_FIELDS_ADDRESS: 7,
  EXTENDED_FIELDS_SELECT_LIST: 8,
  EXTENDED_FIELDS_MEMBERSHIP_STATUS: 9,
  EXTENDED_FIELDS_FILE: 16,

  SIGNUPS_CONFIRMATION_NUMBER: 10,
  SIGNUPS_ITEMS_SIGNED_UP_FOR: 11,
  SIGNUPS_SIGNED_UP_DATE: 12,
  SIGNUPS_TOTAL_NUMBER_OF_ITEMS: 13,
  SIGNUPS_HAS_BEEN_PAID_FOR: 14,
  SIGNUPS_NUMBER_OF_ITEMS: 15,

  SACRAMENT_BOOK_RECORD: 17,
  SACRAMENT_CHURCH: 18,
});

export const SORT_DIRECTIONS = Object.freeze({
  ASCENDING: "asc",
  DESCENDING: "desc",
});

export const ROW_TYPES = Object.freeze({
  USER: 1,
  CUSTOM: 2,
});

export const ROW_ENTITY_TYPES = Object.freeze({
  USER: "user",
  SIGNUP_ADDITIONAL_NAME: "signupAdditionalName",
});

export const isSignupColumn = (columnTypeID) => {
  return (
    columnTypeID === COLUMN_TYPES.SIGNUPS_CONFIRMATION_NUMBER ||
    columnTypeID === COLUMN_TYPES.SIGNUPS_HAS_BEEN_PAID_FOR ||
    columnTypeID === COLUMN_TYPES.SIGNUPS_ITEMS_SIGNED_UP_FOR ||
    columnTypeID === COLUMN_TYPES.SIGNUPS_NUMBER_OF_ITEMS ||
    columnTypeID === COLUMN_TYPES.SIGNUPS_SIGNED_UP_DATE ||
    columnTypeID === COLUMN_TYPES.SIGNUPS_TOTAL_NUMBER_OF_ITEMS
  );
};

export const isExtendedFieldColumn = (columnTypeID) => {
  return (
    columnTypeID === COLUMN_TYPES.EXTENDED_FIELDS_TEXT ||
    columnTypeID === COLUMN_TYPES.EXTENDED_FIELDS_SELECT_LIST ||
    columnTypeID === COLUMN_TYPES.EXTENDED_FIELDS_NUMBER ||
    columnTypeID === COLUMN_TYPES.EXTENDED_FIELDS_MEMBERSHIP_STATUS ||
    columnTypeID === COLUMN_TYPES.EXTENDED_FIELDS_FILE ||
    columnTypeID === COLUMN_TYPES.EXTENDED_FIELDS_DATE ||
    columnTypeID === COLUMN_TYPES.EXTENDED_FIELDS_ADDRESS
  );
};
